/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'smiley': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8z"/><circle pid="1" cx="9" cy="10" r="1.3"/><circle pid="2" cx="15" cy="10" r="1.3"/><path pid="3" d="M12 17c2.33 0 4.32-1.45 5.13-3.5H6.87C7.68 15.55 9.67 17 12 17z"/>'
  }
})
